import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Permissions } from './Guard.jsx';
class PermissionLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            key: this.props.value || '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            key: nextProps.value || '',
        })
    }

    render() {
        switch (this.state.key) {
            case 'admin-menus':
                return <FormattedMessage
                    id="common.permission.admin_menus_label"
                    defaultMessage="Admin menus"
                />
            case 'void-invoice':
                return <FormattedMessage
                    id="common.permission.void_invoice_label"
                    defaultMessage="Void invoice"
                />
            case 'delete-invoice':
                return <FormattedMessage
                    id="common.permission.delete_invoice_label"
                    defaultMessage="Delete sent invoice"
                />
            case 'delete-quote':
                return <FormattedMessage
                    id="common.permission.delete_quote_label"
                    defaultMessage="Delete sent quote"
                />
            case 'manual-invoice-export':
                return <FormattedMessage
                    id="common.permission.manual_invoice_export_label"
                    defaultMessage="Manual invoice export"
                />
            case 'manual-quote-export':
                return <FormattedMessage
                    id="common.permission.manual_quote_export_label"
                    defaultMessage="Manual quote export"
                />
            case 'quick-create':
                return <FormattedMessage
                    id="common.permission.quick_create_label"
                    defaultMessage="Quick create"
                />
            case 'edit-invoice-after-sent':
                return <FormattedMessage
                    id="common.permission.edit_invoice_after_sent_label"
                    defaultMessage="Edit invoice after sent"
                />
            case 'delete-contact':
                return <FormattedMessage
                    id="common.permission.delete_contact_label"
                    defaultMessage="Delete contact"
                />
            case 'show-margin':
                return <FormattedMessage
                    id="common.permission.show_margin_label"
                    defaultMessage="Show margin"
                />
            case 'overwrite-total-price-per-line':
                return <FormattedMessage
                    id="common.permission.overwrite_total_price_per_line"
                    defaultMessage="Overwrite total price per line"
                />
            case 'delete-payment':
                return <FormattedMessage
                    id="common.permission.delete-payment"
                    defaultMessage="Delete payment"
                />
            case 'update-quote-status':
                return <FormattedMessage
                    id="common.permission.update_quote_status"
                    defaultMessage="Update the status of a quote"
                />
            case 'access-all-locations':
                return <FormattedMessage
                    id="common.permission.access_all_location"
                    defaultMessage="Access all locations"
                />
            case 'access-all-users':
                return <FormattedMessage
                    id="common.permission.access_all_users"
                    defaultMessage="Access all users"
                />
            case 'update-role-permissions':
                return <FormattedMessage
                    id="common.permission.update_role_permissions"
                    defaultMessage="Update role permissions"
                />
            case 'update-tax':
                return <FormattedMessage
                    id="common.permission.update_tax_permissions"
                    defaultMessage="Create and update taxes"
                />
            case 'update-fee':
                return <FormattedMessage
                    id="common.permission.update_fee_permissions"
                    defaultMessage="Create and update fees"
                />
            case 'update-custom-field':
                return <FormattedMessage
                    id="common.permission.update_custom_field_permissions"
                    defaultMessage="Create and update custom fields"
                />
            case 'update-payment-term':
                return <FormattedMessage
                    id="common.permission.update_payment_term_permissions"
                    defaultMessage="Create and update payment terms"
                />
            case 'update-custom-payment-type':
                return <FormattedMessage
                    id="common.permission.update_custom_payment_type_permissions"
                    defaultMessage="Create and update custom payment types"
                />
            case 'update-custom-order-status':
                return <FormattedMessage
                    id="common.permission.update_custom_order_status_permissions"
                    defaultMessage="Create and update custom order statuses"
                />
            case 'update-product':
                return <FormattedMessage
                    id="common.permission.update_product_permissions"
                    defaultMessage="Add new products to the catalog and update existing products"
                />
            case 'update-account':
                return <FormattedMessage
                    id="common.permission.update_account_permissions"
                    defaultMessage="Update account information, create and update integrations"
                />
            case Permissions.BypassUpdateCreditLimit:
                return <FormattedMessage
                    id="common.permission.bypass_and_update_credit_limit"
                    defaultMessage="Bypass and update credit limit"
                />
            case Permissions.AccessInventory:
                return <FormattedMessage
                    id="common.permission.access_inventory_module"
                    defaultMessage="Access Inventory Module"
            />
            case Permissions.AccessQuoteMachinePayments:
                return <FormattedMessage
                    id="common.permission.access_qm_payments"
                    defaultMessage="Access QuoteMachine Payments"
                />
        }
        return <div />
    }
}

export default PermissionLabel





// WEBPACK FOOTER //
// ./src/role/permissionlabel.component.jsx